import React from "react";

const testimonials = [
  {
    id: 1,
    name: "Michael Anderson",
    role: "Operations Manager",
    feedback:
      "Awaneez made it incredibly easy to upgrade our office printers. Fast delivery, genuine products, and zero hassle from start to finish.",
    rating: 5,
  },
  {
    id: 2,
    name: "Sara Collins",
    role: "Small Business Owner",
    feedback:
      "Finding the right printer used to be confusing. Awaneez helped me choose the perfect model and everything worked right out of the box.",
    rating: 5,
  },
  {
    id: 3,
    name: "Rahul Mehta",
    role: "Remote Professional",
    feedback:
      "Reliable service and consistent print quality. Their supplies last longer than expected and delivery is always on time.",
    rating: 4,
  },
  {
    id: 4,
    name: "Emily Thompson",
    role: "Creative Designer",
    feedback:
      "Color accuracy and print sharpness are excellent. I trust Awaneez for all my design and photo printing needs.",
    rating: 5,
  },
  {
    id: 5,
    name: "David Wilson",
    role: "IT Administrator",
    feedback:
      "We manage multiple printers across departments. Awaneez provides dependable stock, fair pricing, and responsive assistance.",
    rating: 5,
  },
  {
    id: 6,
    name: "Jessica Brown",
    role: "Office Coordinator",
    feedback:
      "Ordering supplies is quick and straightforward. Everything arrives exactly as described with no surprises.",
    rating: 4,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="sx-testimonials">
      <div className="sx-testimonials-container">
        {/* HEADER */}
        <div className="sx-testimonials-head">
          <h2>Trusted by Professionals & Businesses</h2>
          <p>
            From home offices to growing businesses, customers rely on Awaneez
            for dependable printers, authentic supplies, and smooth ordering.
          </p>
        </div>

        {/* TESTIMONIAL GRID */}
        <div className="sx-testimonials-grid">
          {testimonials.map((item) => (
            <div key={item.id} className="sx-testimonial-card">
              <div className="sx-testimonial-rating">
                {"★".repeat(item.rating)}
                <span>{"★".repeat(5 - item.rating)}</span>
              </div>

              <p className="sx-testimonial-text">“{item.feedback}”</p>

              <div className="sx-testimonial-user">
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= TESTIMONIALS ================= */
        .sx-testimonials {
          padding: 90px 0;
          background: #fff;
        }

        .sx-testimonials-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .sx-testimonials-head {
          text-align: center;
          max-width: 760px;
          margin: 0 auto 60px;
        }

        .sx-testimonials-head h2 {
          font-size: 36px;
          font-weight: 800;
          color: #111;
          margin-bottom: 12px;
        }

        .sx-testimonials-head p {
          font-size: 16px;
          color: #555;
          line-height: 1.7;
        }

        /* GRID */
        .sx-testimonials-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 26px;
        }

        /* CARD */
        .sx-testimonial-card {
          background: #ffffff;
          padding: 30px 28px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          transition: transform .25s ease, box-shadow .25s ease;
        }

        .sx-testimonial-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 40px rgba(0,0,0,0.14);
        }

        /* RATING */
        .sx-testimonial-rating {
          font-size: 18px;
          color: #f59e0b;
          margin-bottom: 14px;
          font-weight: 700;
        }

        .sx-testimonial-rating span {
          color: #e5e7eb;
        }

        /* TEXT */
        .sx-testimonial-text {
          font-size: 15px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 22px;
        }

        /* USER */
        .sx-testimonial-user strong {
          display: block;
          font-size: 16px;
          font-weight: 700;
          color: #111;
        }

        .sx-testimonial-user span {
          font-size: 14px;
          color: #6b7280;
        }

        /* MOBILE */
        @media(max-width: 600px) {
          .sx-testimonials-head h2 {
            font-size: 28px;
          }
        }
      `}</style>
    </section>
  );
}
